let debounceTimers = {};

const sqliteStorage = {
  getItem: async (name) => {
    // In Electron mode, try SQLite first. If SQLite returns null (key not yet flushed
    // due to 100ms debounce, OR genuinely missing), fall back to localStorage which
    // is always written immediately by setItem.
    try {
      if (window.electronAPI?.appState) {
        const sqliteValue = await window.electronAPI.appState.get(name);
        if (sqliteValue != null) return sqliteValue;
        // SQLite returned null — fall through to localStorage (might have pending write)
      }
    } catch (e) {
      console.warn("[sqliteStorage] getItem failed, falling back to localStorage:", e);
    }
    return localStorage.getItem(name);
  },

  setItem: (name, value) => {
    // Write to localStorage synchronously as immediate fallback
    try {
      localStorage.setItem(name, value);
    } catch (e) {
      // localStorage full or unavailable — SQLite is primary anyway
    }

    // Debounced async write to SQLite
    if (window.electronAPI?.appState) {
      clearTimeout(debounceTimers[name]);
      debounceTimers[name] = setTimeout(() => {
        window.electronAPI.appState.put(name, value).catch((e) => {
          console.warn("[sqliteStorage] setItem failed:", e);
        });
      }, 100);
    }
  },

  removeItem: (name) => {
    try {
      localStorage.removeItem(name);
    } catch (e) {
      // ignore
    }
    if (window.electronAPI?.appState) {
      clearTimeout(debounceTimers[name]);
      window.electronAPI.appState.delete(name).catch((e) => {
        console.warn("[sqliteStorage] removeItem failed:", e);
      });
    }
  },
};

export default sqliteStorage;
